import { Link } from "react-router-dom";
import { Wallet } from "@phosphor-icons/react";
import { money, fmtDateTime } from "../lib/api";

const TYPE_LABEL = { refund: "Refund to credit", used: "Used at checkout", trade_in: "Trade-in payout", restored: "Returned (sale voided)" };

// Customer profile: current store credit balance + where it came from / was spent.
export const StoreCreditCard = ({ balance, history = [] }) => (
  <div className="bg-white border border-[#E5E7EB]" data-testid="customer-store-credit">
    <div className={`p-4 flex items-center gap-3 ${balance > 0.005 ? "bg-emerald-50 border-b border-emerald-200" : "border-b border-[#E5E7EB]"}`}>
      <div className={`w-10 h-10 rounded-full flex items-center justify-center ${balance > 0.005 ? "bg-emerald-700" : "bg-slate-300"}`}>
        <Wallet size={18} weight="fill" className="text-white" />
      </div>
      <div className="flex-1">
        <div className="text-[10px] tracking-[0.18em] uppercase font-bold text-emerald-800">Store credit balance</div>
        <div className="text-[22px] font-bold text-emerald-950 mt-0.5 tabular-nums" data-testid="customer-store-credit-balance">${money(balance)}</div>
      </div>
    </div>
    {history.length > 0 ? (
      <div className="divide-y divide-[#E5E7EB] max-h-64 overflow-y-auto" data-testid="customer-credit-history">
        {history.map((h, i) => (
          <div key={`${h.ref}-${h.at}-${i}`} className="px-4 py-2.5 flex items-center justify-between gap-3" data-testid={`credit-history-row-${i}`}>
            <div className="min-w-0">
              <div className="text-[12.5px] font-semibold text-[#121216]">{TYPE_LABEL[h.type] || h.type}</div>
              <div className="text-[11px] text-[#64748B] truncate">
                {fmtDateTime(h.at)} · {h.sale_id ? <Link to={`/sales/${h.sale_id}`} className="underline">{h.ref}</Link> : h.ref}
                {h.by ? ` · ${h.by}` : ""}
              </div>
            </div>
            <div className={`font-mono text-[13px] font-semibold tabular-nums ${h.amount < 0 ? "text-[#DC2626]" : "text-emerald-700"}`}>
              {h.amount < 0 ? "-" : "+"}${money(Math.abs(h.amount))}
            </div>
          </div>
        ))}
      </div>
    ) : (
      <div className="px-4 py-3 text-[12px] text-[#64748B]">No store credit activity yet.</div>
    )}
  </div>
);
